import {IAnyProcessFlowCallToAction, IProcessFlowCallToAction, IProcessFlowMappedVariable} from '~/interfaces/processFlowInterfaces'
import {Hash} from '~/interfaces/hashInterfaces'
import {IClientIdable} from '~/interfaces/propertyInterfaces'
import ProcessFlowCallToAction from '~/models/processFlows/callToActions/processFlowCallToAction'
import {CallToActionType} from '~/enums/processFlows/callToActionType'
import Guid from '~/helpers/guid'
import {Constructor} from '../../global/constructor'

export default function ProcessFlowCallToActionContainer<TBase extends Constructor>(Base: TBase) {
  return class CallToActionContainer extends Base {
    call_to_action: IAnyProcessFlowCallToAction
    // @see ProcessFlowStepDefinition.createEmbeddedDefinitionFactory
    declare createEmbeddedObject: {
      call_to_action: (parent: TBase, json: Hash & Partial<IClientIdable>) => ProcessFlowCallToAction
    }

    get callToAction(): IAnyProcessFlowCallToAction | null {
      return this.call_to_action
    }

    get callToActionVariableReference(): IProcessFlowMappedVariable {
      if ('variableReference' in this.callToAction) {
        return this.callToAction.variableReference
      }
    }

    get allDetailViewIds(): Array<string> {
      if (!this.callToAction) return []

      const ids = []
      if ('detail_view_id' in this.callToAction) {
        if (this.callToAction?.detail_view_id) ids.push(this.callToAction.detail_view_id)
      }
      return ids
    }

    get allListViewIds(): Array<string> {
      if (!this.callToAction) return []

      const ids = []
      if ('list_view_id' in this.callToAction) {
        if (this.callToAction?.list_view_id) ids.push(this.callToAction.list_view_id)
      }
      return ids
    }

    get allFormIds(): Array<string> {
      if (!this.callToAction) return []

      const ids = []
      if ('form_id' in this.callToAction) {
        if (this.callToAction?.form_id) ids.push(this.callToAction.form_id)
      }
      return ids
    }

    createCallToAction(actionType: CallToActionType): IProcessFlowCallToAction {
      const callToAction = this.createEmbeddedObject.call_to_action(this as any, {
        client_id: Guid.create(),
        action_type: actionType,
      })
      callToAction.attachToParent(this as any)
      return callToAction
    }
  }
}